import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=20383946&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"
import style0 from "./setting.vue?vue&type=style&index=0&id=20383946&prod&lang=scss"
import style1 from "./setting.vue?vue&type=style&index=1&id=20383946&prod&lang=scss&scoped=true"
import style2 from "./setting.vue?vue&type=style&index=2&id=20383946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20383946",
  null
  
)

export default component.exports